// Dia de cobrança da assinatura (`subscriptions.billing_day`).
//
// POR QUE ESTE ARQUIVO EXISTE: o banco tem um CHECK que só aceita 1..28
// (`chk_subscriptions_billing_day_range`, migration 20260601000000 — cap pra
// evitar meses curtos, fevereiro à frente). Quem grava o dia cru de `hoje`
// escreve 29, 30 ou 31 nos últimos dias do mês e toma erro do Postgres.
//
// Bug real 2026-08-31: `POST /api/public/checkout` gravava `today.getDate()`
// direto e devolveu 500 em TODA tentativa de pagamento do dia — o cliente via
// "Não foi possível processar o pagamento". Os espelhos saas_direct
// (webhook + reconcile) tinham a mesma linha e quebravam junto.
//
// Regra: NINGUÉM grava billing_day sem passar por aqui.

/** Teto do dia de cobrança. Espelha o CHECK do banco — mudar exige migration. */
export const MAX_BILLING_DAY = 28;

/**
 * Capa um dia do mês (1..31) no intervalo aceito pelo banco (1..28).
 *
 * Dia 29/30/31 vira 28 — o cliente é cobrado no último dia possível do mês,
 * nunca pulando pro mês seguinte. Entrada fora de faixa (0, negativo, NaN)
 * cai no piso 1 em vez de estourar o CHECK.
 */
export function capBillingDay(dayOfMonth: number): number {
  if (!Number.isFinite(dayOfMonth)) return 1;
  return Math.min(Math.max(Math.trunc(dayOfMonth), 1), MAX_BILLING_DAY);
}
